import { PATH_DASHBOARD } from '@app/routes/paths';
import { Strings } from '@app/constants';
import { SvgColor } from '@app/components/svg-color';
// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 40, height: 24 }} />
);

const ICONS = {
  home: icon('ic_dashboard'),
  myMeals: icon('ic_users'),
  findARecipe: icon('ic_players'),
  favorites: icon('ic_locations'),
};

const navConfig = [
  {
    title: Strings.sidebar.home,
    path: PATH_DASHBOARD.homeScreen,
    icon: ICONS.home,
  },
  {
    title: Strings.sidebar.findARecipe,
    path: PATH_DASHBOARD.findARecipeScreen,
    icon: ICONS.findARecipe,
  },
  {
    title: Strings.sidebar.myMeals,
    path: PATH_DASHBOARD.myMealsScreen,
    icon: ICONS.myMeals,
  },
  {
    title: Strings.sidebar.favorites,
    path: PATH_DASHBOARD.favoritesScreen,
    icon: ICONS.favorites,
  },
];

export default navConfig;
